<mat-form-field
  class="select-classic mb-[22px] w-full"
  appearance="outline"
>
  <mat-select
    (valueChange)="changed.emit($event)"
    [value]="value()"
    panelClass="single-select-overlay"
    placeholder="Select device"
  >
    @for (device of devices(); track device.id) {
      <mat-option [value]="device.id">
        {{ device.deviceName }}
      </mat-option>
    }
  </mat-select>
  <mat-icon
    class="arrow-down"
    matSuffix
  >keyboard_arrow_down</mat-icon>
</mat-form-field>
